import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import { headersTitles } from "./MyPaymentsVariables";
import SaleOrderSelect from "../../components/SaleOrderSelect/SaleOrderSelect";

import { connect } from 'react-redux';
import { fetchMyPayments } from 'reducers/mypayments/mypaymentsActions'

import {
  SALEORDER_WITH_PAYMENTS
} from "constants/saleOrderTypeConst"

class MyPaymentsView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      saleOrder: {
        id: 0,
        name: ""
      }
    };
    this.loadPayments = this.loadPayments.bind(this);
  }

  componentWillMount() {
    console.log("MyPaymentsView : componentWillMount");
  }

  loadPayments(saleOrder) {
    this.setState({ saleOrder: saleOrder });
    this.props.fetchMyPayments(saleOrder.id);
  }

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <Col md={6}>
                      <SaleOrderSelect
                        onRef={ref => (this.saleOrderSelect = ref)}
                        loadParentContent={this.loadPayments}
                        firstItemLabel="TODOS"
                        saleOrder={this.state.saleOrder}
                        saleOrderType={SALEORDER_WITH_PAYMENTS}
                      />
                    </Col>

                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          {headersTitles.map((prop, key) => {
                            return <th key={key}>{prop}</th>;
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.mypayments.map((prop, key) => {
                          return (
                            <tr key={key}>
                              <td>{prop.collectionNumber}</td>
                              <td>{prop.project}</td>
                              <td>{prop.land}</td>
                              <td>{prop.description}</td>
                              <td>{prop.paymentType}</td>
                              <td>{prop.origin}</td>
                              <td>{prop.paidDateFormatted}</td>
                              <td className="text-right">{prop.amountFormatted}</td>
                              <td className="text-right">{prop.paidFormatted}</td>
                              <td className="text-right">{prop.balanceFormatted}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>

                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  mypayments: state.mypayments.items
});

export default connect(mapStateToProps, { fetchMyPayments })(MyPaymentsView);


// WEBPACK FOOTER //
// ./src/views/MyPayments/MyPaymentsView.jsx